var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoreIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18498 4.00961C8.57434 4.00961 8.88998 3.69397 8.88998 3.30461C8.88998 2.91525 8.57434 2.59961 8.18498 2.59961C7.79562 2.59961 7.47998 2.91525 7.47998 3.30461C7.47998 3.69397 7.79562 4.00961 8.18498 4.00961Z",
    stroke: "#0245A9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18498 8.7352C8.57434 8.7352 8.88998 8.41956 8.88998 8.0302C8.88998 7.64083 8.57434 7.3252 8.18498 7.3252C7.79562 7.3252 7.47998 7.64083 7.47998 8.0302C7.47998 8.41956 7.79562 8.7352 8.18498 8.7352Z",
    stroke: "#0245A9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.18498 13.4598C8.57434 13.4598 8.88998 13.1442 8.88998 12.7548C8.88998 12.3654 8.57434 12.0498 8.18498 12.0498C7.79562 12.0498 7.47998 12.3654 7.47998 12.7548C7.47998 13.1442 7.79562 13.4598 8.18498 13.4598Z",
    stroke: "#0245A9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreIcon);
export default __webpack_public_path__ + "static/media/more-icon.a1b9f1eb12dfa3106be3990fe999652d.svg";
export { ForwardRef as ReactComponent };